/**
 * EPR – L'EPR project translations
 */

import settings from "./settings.js";
import reporting from "./reporting.js";
import epr from "./epr.js";

export default {
  ...settings,
  ...epr,
  eprReporting: reporting,
};
